// ============================================================================
// view.cattlebreeding — migrated off the global read
// ============================================================================
// The cattle breeding-cycle list. Its three page-owned reads (cycles, calving
// records, and the narrowed id/tag/herd cattle projection) move to the
// `cattle.breeding.core` catalog resource.
//
// This migration also CLOSED a real defect rather than merely relocating the
// reads. The page-local loader swallowed every read failure — `if (cR.data)
// setCycles(cR.data)` — and then cleared loading unconditionally, so a failed
// read rendered "No breeding cycles yet. Click + New Cycle to record one."
// That reads as "the farm has none" and invites a duplicate cycle. The
// resource throws, and the consumer gained a mutually-exclusive error branch
// with Retry.
// ============================================================================

import type {MigratedSurfaceDeclaration} from '../surfaceDataManifest';

const declaration: MigratedSurfaceDeclaration = Object.freeze({
  surface: 'view.cattlebreeding',
  obligations: Object.freeze([Object.freeze({id: 'cattle.breeding.core', owner: 'permanent'})]),
  residualLegacy: Object.freeze([]),
});

export default declaration;
